import React from 'react';
import BaseForm from 'containers/Base/BaseForm.js';
import PropTypes from 'prop-types';
import {
  visitorTypeActions,
  visitorTypeSelectors,
} from 'containers/Pages/Locations/VisitorTypes';
import { connect, useSelector } from 'react-redux';
import { validateString, validationObject } from 'utils/validations';
import { PAGE_URLS } from 'utils/constants';

const initialState = {
  typeName: undefined,
  archived: false,
  id: undefined,
};
export const validationSchema = validationObject({
  typeName: validateString(50, true),
});
const initialValues = data => {
  return data;
};
const VisitorTypeForm = ({
  editMode,
  closeForm,
  createVisitorType,
  updateVisitorType,
  persistentStateName = PAGE_URLS.VISITOR_TYPES,
}) => {
  const details = useSelector(state =>
    visitorTypeSelectors.getVisitorTypeRaw(state),
  );
  const onEdit = values => {
    updateVisitorType({
      visitorType: { ...values },
    });
  };
  const onCreate = values => {
    createVisitorType({
      visitorType: { ...values },
    });
  };
  const generalSection = () => {
    return [
      {
        field: 'typeName',
        label: 'Name',
        type: 'text',
        required: true,
      },
    ];
  };
  return (
    <BaseForm
      imageRequired={false}
      allowToArchive={true}
      generalSection={generalSection()}
      edit={editMode}
      onSubmit={editMode ? onEdit : onCreate}
      formTitle={editMode ? 'Edit Visitor Type' : 'Create Visitor Type'}
      closeForm={closeForm}
      initialValues={editMode ? initialValues(details) : initialState}
      persistentStateName={persistentStateName}
      validationSchema={validationSchema}
    />
  );
};
VisitorTypeForm.propTypes = {
  editMode: PropTypes.bool,
  closeForm: PropTypes.func,
  id: PropTypes.string,
  persistentStateName: PropTypes.string,
  createVisitorType: PropTypes.func,
  updateVisitorType: PropTypes.func,
  details: PropTypes.object,
};
const mapDispatchToProps = dispatch => ({
  createVisitorType: ({ visitorType }) =>
    dispatch(visitorTypeActions.createRowEntry({ visitorType })),
  updateVisitorType: ({ visitorType }) =>
    dispatch(visitorTypeActions.updateRowEntry({ visitorType })),
});
export default connect(null, mapDispatchToProps)(VisitorTypeForm);
